import React from 'react';
import rawMarkup from '../../util/rawMarkup';



export default class ConceptAdScript extends React.PureComponent {
	

  render() {
    //let scriptContent = `<script src="https://cdn.adnuntius.com/adn.js" async></script>`;
	
let scriptContent = `
    window.adn = window.adn || {}; adn.calls = adn.calls || [];
adn.calls.push(function() {
   adn.request({ adUnits: [
      { auId: '00000000000b30a6', auW: '930', auH: '180', useCookies: false   }
   ]});
});
`;
    return (
    <div>
    <script src="https://tags.adnuntius.com/concept_cph/zUxMC1rEr.prod.js" async></script>
      <script type="text/javascript" dangerouslySetInnerHTML={rawMarkup(scriptContent)} />
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Ads/ConceptAdScript.jsx